/**
 * Claude Code config writer
 *
 * Skill: ~/.agents/skills/sailfish-autofix/ (cross-client) + ~/.claude/skills/sailfish-autofix/
 * MCP: ~/.claude.json mcpServers.sailfishAutofix
 */

import { homedir } from "os";
import { join } from "path";
import type { AgentConfigWriter } from "./base.js";
import { copySkillTo, removeSkillFrom, installCrossClientSkill, removeCrossClientSkill, buildMcpEntry, mutateJsonFile } from "./base.js";
import { MCP_SERVER_NAME } from "../constants.js";

const CLAUDE_SKILLS_DIR = join(homedir(), ".claude", "skills");
const CLAUDE_CONFIG = join(homedir(), ".claude.json");

export const claudeCode: AgentConfigWriter = {
  id: "claude-code",
  name: "Claude Code",

  installSkill(global: boolean) {
    // Install to cross-client path
    installCrossClientSkill(global);
    // Also install to Claude Code's own skills directory
    copySkillTo(CLAUDE_SKILLS_DIR);
  },

  installMcp() {
    mutateJsonFile(CLAUDE_CONFIG, (config) => {
      if (!config.mcpServers) config.mcpServers = {};
      config.mcpServers[MCP_SERVER_NAME] = buildMcpEntry();
      return config;
    });
  },

  uninstallSkill() {
    removeCrossClientSkill(true);
    removeSkillFrom(CLAUDE_SKILLS_DIR);
  },

  uninstallMcp() {
    mutateJsonFile(CLAUDE_CONFIG, (config) => {
      if (config.mcpServers?.[MCP_SERVER_NAME]) {
        delete config.mcpServers[MCP_SERVER_NAME];
      }
      return config;
    }, false);
  },
};
